// Register the service worker so Aarya can be installed and works offline-light.
// Loaded from index.html via a tiny inline tag below - but we keep the impl here for clarity.
export function registerAaryaServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
